import * as React from "react";
import { Container, TituloSecao } from "./styles";
import Grid from "../../componentes/Grid";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import userContext from "../../Context/UserContext";
import { FormatarUrlName } from "../../helpers/valores";

const Pesquisa: React.FC = () => {
  const { name }: any = useParams();
  const currentlyUser = useContext(userContext);
  const { Codcliente, Codempresacli } = currentlyUser.user;
  const nomeFormatado = FormatarUrlName(decodeURIComponent(name));

  return (
    <Container>
      <TituloSecao>Pesquisa {nomeFormatado}</TituloSecao>
      <Grid
        Titulo={"Pesquisa:" + nomeFormatado}
        Pesquisa={decodeURIComponent(name)}
        Codcliente={Codcliente}
        Codempresacli={Codempresacli}
      />
    </Container>
  );
};

export default Pesquisa;
